







































































import { Component, Inject, Vue, Ref } from "vue-property-decorator";
import {
  IContractCancellationProvider,
  IContractCancellationMethods
} from "@/models/providers/contractCancellation";
import { RefundOptions, RefundSources } from "@/data/enums/payments";
import InvoicesListing from "@/components/app/global/invoices/invoicesListing.vue";

import { IInvoice } from "@/models/invoices";

@Component({
  components: {
    InvoicesListing
  }
})
export default class ContractCancellationRefundOptions extends Vue {
  // Inject
  @Inject({ from: "contractCancellationProvider" })
  public readonly $provider!: () => IContractCancellationProvider;
  @Inject({ from: "contractCancellationMethods" })
  public readonly $methods!: IContractCancellationMethods;
  // Refs
  @Ref()
  public invoicesListing!: InvoicesListing;
  // Data
  public sources: typeof RefundSources = RefundSources;

  public created() {
    const fullRefundOption = this.$_.find(this.provider.refundOptions, [
      "id",
      RefundOptions.FULL_REFUND
    ]);
    if (this.provider.isInMoneyBackPeriod && fullRefundOption) {
      this.$methods.selectRefundOption(fullRefundOption);
    }
    const noRefundOption = this.$_.find(this.provider.refundOptions, [
      "id",
      RefundOptions.NO_REFUND
    ]);
    if (!this.provider.moneyBackPeriod && noRefundOption) {
      this.$methods.selectRefundOption(noRefundOption);
    }
  }

  // Computed
  public get provider() {
    return this.$provider();
  }
  public get refundOption() {
    return this.$_.find(this.provider.refundOptions, [
      "id",
      this.provider.refundOption
    ]);
  }
  public get showRefundSource() {
    return this.provider.refundOption;
  }
  public get showInvoicesTable() {
    return this.provider.refundOption === RefundOptions.NO_REFUND;
  }
  // Methods
  public async openInvoiceCancellationModal(invoice: IInvoice) {
    return this.$store.dispatch("ui/open/slideModal", {
      config: {
        component: () =>
          import(
            "@/components/app/global/invoices/invoiceCreditRefundModal.vue"
          ),
        props: {
          invoice
        },
        events: {
          "invoice-updated": () =>
            this.invoicesListing && this.invoicesListing.reloadData()
        }
      }
    });
  }
}
